"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProgressBarBackground = void 0;
var _index = require("../../styles/index.js");
var _styledComponents = _interopRequireDefault(require("../../styled-components.js"));
var ProgressBarBackground = exports.ProgressBarBackground = _styledComponents["default"].div.withConfig({
  displayName: "ProgressBarBackground",
  componentId: "sc-1q0p8ti-0"
})(["background-color:", ";block-size:6px;border-radius:", ";"], (0, _index.cssColorValue)(_index.semanticColors.backgroundTintedBase), _index.borderRadiusRounded);